import { supabase } from "@/lib/supabase";

export type ConciergeEventType =
  | "page_view"
  | "resource_view"
  | "resource_complete"
  | "session_start"
  | "session_end";

const sb = supabase as any;

/**
 * Emit a Concierge engagement event. No-ops silently on any failure
 * (RLS + trigger will already block if consent isn't active).
 */
export async function emitConciergeEvent(
  siteId: string,
  eventType: ConciergeEventType,
  opts?: { resource_id?: string | null; metadata?: Record<string, unknown> },
): Promise<void> {
  try {
    const { data: userData } = await supabase.auth.getUser();
    const uid = userData.user?.id;
    if (!uid) return;

    const { error } = await sb.from("concierge_events").insert({
      site_id: siteId,
      user_id: uid,
      event_type: eventType,
      resource_id: opts?.resource_id ?? null,
      metadata: opts?.metadata ?? {},
    });
    if (error) {
      if (import.meta.env.DEV) console.debug("[concierge] event blocked", eventType, error.message);
    }
  } catch (e) {
    if (import.meta.env.DEV) console.debug("[concierge] event error", e);
  }
}
